
export enum EnvironmentType {
    Development = 0,
    Test = 1,
    Production = 2
}